interface ProgressStep {
  id: string
  heading: string
  body: string
  status: 'default' | 'active' | 'completed' | 'warning'
}

export const progressData: ProgressStep[] = [
  {
    id: 'developerDetails',
    body: 'Upload and verify Developers evidence',
    heading: 'Developer Input Files',
    status: 'active',
  },
  {
    id: 'devAppropriateness',
    body: 'Evaluate Developers Appropriateness',
    heading: 'Developer Appropriateness',
    status: 'default',
  },
  {
    id: 'implementerDetails',
    body: 'Upload and verify Implementers evidence',
    heading: 'Implementer Input Files',
    status: 'default',
  },
  {
    id: 'impAppropriateness',
    body: 'Evaluate Implementers Appropriateness',
    heading: 'Implementer Appropriateness',
    status: 'default',
  },
  {
    id: 'SODAnalysis',
    body: 'View SOD Analysis Results',
    heading: 'Results Page',
    status: 'default',
  },
]
